export interface SocialMediaUrls {
  url_facebook: string,
  url_instagram: string,
  url_linkedin: string,
  url_pinterest: string,
  url_tiktok: string,
  url_twitter: string,
  url_youtube: string
}

export enum SocialMediaUrl {
  FACEBOOK = 'url_facebook',
  INSTAGRAM = 'url_instagram',
  LINKEDIN = 'url_linkedin',
  PINTEREST = 'url_pinterest',
  TIKTOK = 'url_tiktok',
  TWITTER = 'url_twitter',
  YOUTUBE = 'url_youtube'
}
